import { ImportError } from './ImportError'

/**
 * Error that is thrown when a import value is not a valid form factor.
 */
export class ImportFormFactorError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportFormFactorError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
